export enum ECustomerTypeSelection {
  Myself = 'Myself',
  ExistingCustomer = 'ExistingCustomer',
  NewCustomer = 'NewCustomer',
}
